import { createSlice } from "@reduxjs/toolkit";

const user = createSlice({
  name: "user",
  initialState: {
    username: null,
    userId: null,
    accessToken: null,
    error: null,
    avatar: "",
    email: "",
  },
  reducers: {
    setUsername: (store, action) => {
      store.username = action.payload;
    },
    setUserId: (store, action) => {
      store.userId = action.payload;
    },
    setAccessToken: (store, action) => {
      store.accessToken = action.payload;
    },
    setError: (store, action) => {
      store.error = action.payload;
    },
    setSavedSights: (store, action) => {
      store.error = action.payload;
    },
    setAvatar: (store, action) => {
      store.avatar = action.payload;
    },
    setEmail: (store, action) => {
      store.email = action.payload;
    },
  },
});

export default user;
